<template>
    <div>
        <div class="row">
            <div class="col-lg-12">
                <b-card no-body :header="$t('general.subcontractors.painting_price_list.title')" header-tag="h3" class="bg-default-card">
                    <span v-if="showTableBarLoader">
                        <BarLoader 
                            class="my-custom-bar-loader"
                            :color="'#6f9fe6'"
                        >
                        </BarLoader>
                    </span>
                    <price-list-table
                        :addButtonTitle="$t('general.subcontractors.painting_price_list.create_button')"
                        :priceListType="'painting'"
                        :columnData="columnData"
                        @showSpinnerFunction="showSpinnerFunction"
                    >
                    </price-list-table>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import PriceListTable from '@/components/pages/project/subcontractors/price_list/price_list_table.vue';
import { BarLoader } from '@saeris/vue-spinners';

export default {
    name: 'painting_price_list',
    components: {
        PriceListTable,
        BarLoader,
    },
    data() {
        return {
            columnData: [
                {
                    label: Vue.i18n.translate('misc.actions'),
                    width: '90px',
                    field: '',
                    showEditButton: true,
                    showDeleteButton: true,
                },
                {
                    label: Vue.i18n.translate('table.company'),
                    field: 'company_name',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.price_type'),
                    field: 'price_typeV',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_painting_no'),
                    field: 'part_painting_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_painting_description'),
                    field: 'part_painting_description',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_painting_code'),
                    field: 'part_painting_code',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_painting_thickness'),
                    field: 'part_painting_thickness',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_painting_color'),
                    field: 'part_painting_color',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.measureunit'),
                    field: 'measureunitV',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.work_price'),
                    field: 'work_price',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.material_price'),
                    field: 'material_price',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.other_price'),
                    field: 'other_price',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.currency'),
                    field: 'currency',
                    numeric: false,
                    html: false,
                }
            ],
            showTableBarLoader: false,
        }
    },
    methods: {
        showSpinnerFunction (value) {
            this.showTableBarLoader = value;
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/pages/project/subcontractors/price_list/price_list_tables/painting_price_list.vue